export enum PremiumFeatures {
  Menus = 'Menus',
  Listings = 'Listings',
  ReviewMonitoring = 'ReviewMonitoring',
  ManagedReviewsInternal = 'ManagedReviewsInternal',
  ManagedReviewsExternal = 'ManagedReviewsExternal',
  SocialManagement = 'SocialManagement',
  WidgetMenus = 'WidgetMenus',
  WidgetHours = 'WidgetHours',
  WidgetReviewForms = 'WidgetReviewForms',
}

export const AccountStatusValues = [
  'SUSPENDED',
  'ACTIVE',
  'TRIAL_ACTIVE',
  'TRIAL_EXPIRED',
  'PENDING',
  'PAST_DUE',
  'CANCELLED',
  'TERMINATED',
] as const

export type AccountStatus = (typeof AccountStatusValues)[number]

export interface PremiumFeaturesProps {
  features?: PremiumFeatures[]
  status?: AccountStatus
}

export type PaymentIssue = {
  paymentAttempts: number
  gracePeriod: Date
  lastAttempt: Date
}

export interface PremiumFeaturesReturnProps {
  features: PremiumFeatures[]
  status: AccountStatus
  paymentIssue?: PaymentIssue
}
